import { TRANSACTIONS_API_ENDPOINT } from "../../../constants/constant";
import baseApi from "../../baseApi";
import { ApiResponse, ResultType, TransactionsType } from "./transactions.type";

export interface UserQueryParams {
  search?: string;
  status?: string;
  userType?: string;
  transactionType?: string;
  fromDate?: string;
  toDate?: string;
  page?: number;
  limit?: number;
  userId?: string;
  campaignId?: string;
  isCompleted?: boolean;
  isClaimed?: boolean;
}

export const transactionsApiSlice = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTransactionsApiCall: build.query<
      ApiResponse<ResultType<TransactionsType>>,
      UserQueryParams | void
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();

        if (params?.search) queryParams.append("search", params.search);
        if (params?.status) queryParams.append("status", params.status);
        if (params?.transactionType)
          queryParams.append("transactionType", params.transactionType);
        if (params?.fromDate) queryParams.append("fromDate", params.fromDate);
        if (params?.toDate) queryParams.append("toDate", params.toDate);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.limit) queryParams.append("limit", params.limit.toString());
        if (params?.userId) queryParams.append("userId", params.userId);
        if (params?.campaignId)
          queryParams.append("campaignId", params.campaignId);
        if (params?.isCompleted !== undefined) {
          queryParams.append("isCompleted", String(params.isCompleted));
        }

        if (params?.isClaimed !== undefined) {
          queryParams.append("isClaimed", String(params.isClaimed));
        }

        return `${
          TRANSACTIONS_API_ENDPOINT.GET_TRANSACTIONS
        }?${queryParams.toString()}`;
      },
      // providesTags: ["Users"],
    }),
  }),
});

export const {
  useGetTransactionsApiCallQuery,
  useLazyGetTransactionsApiCallQuery,
} = transactionsApiSlice;

export default transactionsApiSlice;
